<template>
  <button
    :id="btnAddItem"
    @click="$emit('add-order', product)"
    :disabled="isClose" v-tooltip.top="productName"
    class="group relative bg-white border border-gray-200 shadow-sm hover:shadow-md rounded-md overflow-hidden transition-all duration-200 flex flex-col h-40 w-full text-left active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed hover:border-primary/30"
    :class="{ 'opacity-50 cursor-not-allowed': isClose }"
  >
    <!-- Image Section -->
    <div class="relative h-20 bg-gray-50 w-full">
      <div
        v-if="product.monitor_stock"
        class="absolute top-1.5 left-1.5 px-1.5 py-0.5 text-xs rounded-full font-medium"
        :class="{
          'bg-red-500 text-white': product.stock <= 0,
          'bg-amber-500 text-black': product.stock > 0 && product.stock < 5,
          'bg-green-500 text-white': product.stock >= 5
        }"
        v-tooltip.top="product.stock"
      >
        {{ product.stock }}
      </div>
      <img
        v-if="product.image"
        :src="product.image"
        :alt="productName"
        class="w-full h-full object-cover"
      />
      <div
        v-else
        class="w-full h-full flex items-center justify-center text-gray-400"
      >
        <PhotoIcon class="w-8 h-8" />
      </div>
      <!-- Menu Type Badge -->
      <div
        class="absolute top-1.5 right-1.5 px-1.5 py-0.5 text-xs rounded-full font-medium bg-primary/10 text-primary"
      >
        {{ product.itemCategory?.name }}
      </div>
    </div>

    <!-- Content Section -->
    <div class="flex flex-col flex-grow p-2.5 w-full">
      <!-- Product Name -->
      <div class="min-h-[2rem] flex items-center">
        <h3
          class="font-semibold text-gray-900 text-sm line-clamp-2 break-words w-full"
        >
          {{ productName }}
        </h3>
      </div>
      <div v-if="product.has_product_mix" class="mt-1 w-full">
        <span class="inline-block bg-green-50 text-green-700 text-xs px-1.5 py-0.5 rounded line-clamp-1 w-full overflow-hidden text-ellipsis">
          {{ product.product_mix?.map(mix => mix.name).join(', ') }}
        </span>
      </div>

      <!-- Price -->
      <div class="mt-auto w-full">
        <div class="flex items-center justify-between w-full">
          <p class="text-gray-900 font-semibold text-sm" :class="{ 'line-through text-gray-400': product.discount_price > 0 }">
            {{ productPrice }}
          </p>
          <p v-if="product.discount_price > 0" class="text-green-600 font-semibold text-sm">
            {{ formatPrice(parseFloat(product.sale_price) - parseFloat(product.discount_price)) }}
          </p>
        </div>
        <div v-if="product.max_qty > 0" class="flex items-center justify-start w-full">
          <p class="text-gray-500 text-xs">
            Max: {{ product.max_qty }}
          </p>
        </div>
      </div>
    </div>
  </button>
</template>

<script>
import { PhotoIcon } from "@heroicons/vue/24/outline";

export default {
  name: "ProductCard",
  components: {
    PhotoIcon,
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    productPrice: {
      type: String,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    btnAddItem: {
      type: String,
      required: true,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    },
  },
};
</script>
